import { useTranslation } from "react-i18next";
import { useOnline } from "@/hooks/use-online";
import { cn } from "@/lib/utils";

export interface ConnectionPillProps {
  className?: string;
}

export function ConnectionPill({ className }: ConnectionPillProps) {
  const { t } = useTranslation();
  const online = useOnline();

  if (online) return null;

  return (
    <span
      role="status"
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full bg-surface-2 px-2.5 py-0.5 text-[11px] font-medium text-ink-500 ring-1 ring-line",
        className,
      )}
    >
      <span aria-hidden className="size-1.5 rounded-full bg-ink-400" />
      {t("connection.offline")}
    </span>
  );
}
